<template>
  <div v-if="auditType">
    <el-dialog :close-on-click-modal='false'
               v-model="dialogVisible"
               append-to-body
               class="dialognewclass oa-examine-comment">
      <div class="textarea">
        <el-input
          id="textarea"
          type="textarea"
          style="resize:none"
          :rows="7"
          :placeholder="'请输入你的'+Number(auditType.item) === 2 ? '意见' : '评论'"
          v-model="textarea">
        </el-input>
      </div>
      <el-row class="calbtn">
        <el-col :span="12">
          <template v-for="(item,index) in tabPane" >
            <p class="p" 
              v-if="index!==2 || isSign"
              :key="item.id" 
              :class="[tabActive==index?'active':'',index==2 && auditType.issign == 1 && isSign && signImg === ''?'redDot':'']" 
              @click="ontabs(index)">
              <i :class="item.icon"></i>
            </p>
          </template>
          <el-button @click="addComment">添加为常用语</el-button>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <el-button type="primary" size="small" :disabled="isButtonLoading" v-loading="isButtonLoading" @click="subComment" style="width:88px">{{auditType.text || '提交'}}</el-button>
        </el-col>
      </el-row>
      <el-scrollbar class="el-menu-scrollbar__wrap scrollbarbox">
        <div class="ul" v-if="tabActive==0" style="padding:20px 0">
          <div class="li comment-text" v-for="(list, index) in commentComputed" :key="list.key">
            <el-input ref="cInput" @blur="handleChangeComment(list)" v-model="list.value" v-if="list.isInput" ></el-input>
            <span type="text" class="p" v-else @click="addText(list.value)">{{list.value}}</span>
            <div class="todo-icon">
              <i class="icon WSiconfont WSicon-datouding" v-if="list.order" title="取消置顶" @click="cancleTopComment(list,index)"></i>
              <i class="icon WSiconfont WSicon-datouding1" v-else title="置顶" @click="toTopComment(list,index)"></i>
              <i class="icon WSiconfont WSicon-bianji1" @click="editComment(list,index)"></i>
              <i class="icon WSiconfont WSicon-shanchu1" @click="delComment(index)"></i>
            </div>
          </div>
        </div>
        <div class="ul" v-else-if="tabActive==1">
          <el-upload :action="$url+'/userfile/upload?accesstoken='+token"
                      :file-list="notefile" class="img-file-class no-details"
                      :on-progress="handleProgress" list-type="text" :on-preview="handlePreview"
                      :on-success="handleSuccess"
                      :on-remove="handleRemove" :before-upload="beforeFileUpload"
                      :multiple='true'>
              <div class="upfile">+ 添加文件</div>
            </el-upload>
        </div>
        <div class="ul" v-show="tabActive==2">
          <div class="signBtns">
            <el-button class="signBtn" type="primary" @click="handleReset">重 签</el-button>
            <el-button class="signBtn" type="primary" @click="upSigna">确 定</el-button>
          </div>
          <vue-esign ref="esign" class="canvas" :width="920" :height="170" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" v-model:bgColor="bgColor" />

        </div>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
  import {
    openapiReview,
    openapiGetcommonlanguagelist,
    openapiAddcommonlanguage,
    openapiUpdateuserapproving,
    openapiUpdatetransactor
  } from '@/port/clientSide/oaExamineComment'
  import Axios from 'axios';  

  import {fileFormatted, fileListForeach, filePreview} from "@/api/global.js";
  import vueEsign from 'vue-esign'

  export default {
    // templateDate 模板原始值数据 templateModify 模板解析数据
    props:{
      templateDate:{}, 
      templateModify:{},
    },
    data() {
      return{
        dialogVisible: false,
        textarea: '',
        comment: [],
        notefile:[],
        auditType: null,
        tabActive:0,
        tabPane:[{icon:'icon iconfont icon-001xin2x-02'},{icon:'icon iconfont icon-tianjiafujian'},{icon:'icon iconfont icon-faqi'}],
        isButtonLoading: false,
        lineWidth: 6,
        lineColor: '#000000',
        bgColor: '',
        resultImg: '',
        isCrop: false,
        signImg: '',
        isSign: false,
        token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
      }
    },
    components:{
      vueEsign
    },
    computed:{
      commentComputed(){
        let top = this.comment.filter(item=>item.order)
        if (top.length !== 0) {
          top = top.sort((a,b)=>b.order-a.order)
        }
        const noTop = this.comment.filter(item=>!item.order)
        return [...top,...noTop]
      }
    },
    watch: {
      'dialogVisible'(){
        if (!this.dialogVisible) {
          this.resetFun()
          this.signImg = ''
          this.$emit('loadingFun', false)
        }
      }
    },
    methods: {
      // 重签
      handleReset(){
        this.$refs.esign.reset()
        this.signImg = ''
      },
      base64ImgtoFile(dataurl, filename = 'file') {
        const arr = dataurl.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const suffix = mime.split('/')[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], `${filename}.${suffix}`, {
          type: mime
        })
      },
      // 签名生成图片
      async upSigna() {
        this.$refs.esign.generate().then(res => {
          const blob = this.base64ImgtoFile(res,'name')
          const name = 'name.png'
          const file = new File([blob], name, {
            type: 'image/png'
          })
          const formData = new FormData()
          const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
          formData.append("file", file) 
          let url = '/userfile/upload?accesstoken='+token
          let config = {
            headers:{
              'Content-Type':'multipart/form-data',
            },
          };
          // let type = this._indexS.title + "_" + this._indexS.type

          Axios.post(url, formData, config)
            .then(res => {
              if(res.data){
                this.signImg = fileListForeach([{response: res.data}])[0].response
                // this.token = JSON.parse(localStorage.getItem('user')).accesstoken
                // this.formdata[type] = 
                // this.$refs.esign.reset()
              }
            }).catch(err => {
              console.log('图片上传错误', err)
          })
        })
      },
      //添加常用语
      ontabs(i){
        this.tabActive = i
      },
      addComment () {
        if (this.textarea === '') {
          this.$message({
            type: "error",
            message: "需要新增的常用语不能为空!"
          })
          return false
        }
        let allDate = JSON.parse(JSON.stringify(this.comment))
        allDate.push({
          value: this.textarea,
          key: Date.now()
        })
        openapiAddcommonlanguage({
          content: JSON.stringify(allDate)
        }).then(res => {
          this.tabActive = 0
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '常用语添加成功'
            })
            this.comment = allDate
          } else {
            this.$message({
              type: 'error',
              message: '常用语添加失败'
            })
          }
        }).catch(error => {
          console.log(error)
        })
      },
      toTopComment(list){
        // 置顶操作
        let top = this.comment.filter(item=>item.order)
        let max = 0
        if (top.length !== 0) {
          top = top.sort((a,b)=>b.order-a.order)
          max = top[0].order
        }
        this.$set(list,'order',max + 1)
        try {
          this.requestAddApi()
          this.$message.success('置顶成功')
        } catch (error) {
          console.log(error);          
        }
      },
      cancleTopComment(list){
        // 取消置顶
        this.$delete(list,'order')
        try {
          this.requestAddApi()
          this.$message.success('取消置顶成功')
        } catch (error) {
          console.log(error);          
        }
      },
      handleChangeComment(list){
        // 输入结束
        list.isInput = false
        try {
          this.requestAddApi()
          this.$message.success('修改成功')
        } catch (error) {
          console.log(error)
        }
      },
      requestAddApi(){
        let addComment = JSON.parse(JSON.stringify(this.commentComputed))
        openapiAddcommonlanguage({
          content: JSON.stringify(addComment)
        }).then(res => {
          if (res.code === 0) {
            this.comment = addComment
          }
        }).catch(error => {
          console.log(error)
        })
      },
      editComment(list){
        // 编辑常用语
        if (!list.isInput) {
          this.$set(list,'isInput',true)
          const timer = setTimeout(() => {
            this.$refs.cInput[0].focus()
            clearTimeout(timer)
          }, 10);
        }
      },
      //删除常用语
      delComment(index) {
        let addComment = JSON.parse(JSON.stringify(this.commentComputed))
        addComment.splice(index, 1)
        openapiAddcommonlanguage({
          content: JSON.stringify(addComment)
        }).then(res => {
          if (res.code === 0) {
            this.$message({type: 'success', message: '删除常用语成功'})
            this.comment = addComment
            console.log(this.comment)
          } else {
            this.$message({type: 'error', message: '删除常用语失败'})
          }
        }).catch(error => {
          console.log(error)
        })
      },
      //添加到文本域
      addText (e) {
        let selection= window.getSelection ? window.getSelection() : document.selection;
        let range= selection.createRange ? selection.createRange() : selection.getRangeAt(0);
        console.log('贯标锁在位置', range)
        //获取光标所在位置
        if (range.startContainer.childNodes[0] !== undefined) {
          let len = range.startContainer.childNodes[0].selectionStart
          let date = JSON.parse(JSON.stringify(this.textarea))
          let left = date.slice(0, len)
          let right = date.slice(len, date.length)
          this.textarea = left + e + right
        } else {
          this.textarea = this.textarea + e
        }
      },
      getComment () {
        let date = {
          curpage: 0,
          pagesize: 0
        }
        openapiGetcommonlanguagelist(date).then(res => {
          console.log(res)
          if (res.data) {
            this.comment = res.data
          }
        }).catch(error => {
          console.log(error)
        })
      },
      handleProgress(event, file, fileList) {
        // 过滤掉文件名里面的 # 号
        if (file.name) {
          file.name = (file.name).replace(/^#+|#|#+$/g, "");
        }
        console.log("handleProgress==", event, file, fileList)
      },
      //图片，附件上传打开本地文件夹
      handlePreview(file) {
        filePreview({url: file.url ? file.url : file.response})
      },
      //图片，附件上传。上传成功
      handleSuccess(response, file, fileList) {
        this.notefile = fileListForeach(fileList)
      },
      //图片,附件删除
      handleRemove(file, fileList) {
       this.notefile = fileList
      },
      //附件上传
      beforeFileUpload(file) {
        if(!fileFormatted(file.name)){
          this.$message.error('上传附件格式不对!');
          return false;
        }
        if (file.size / 1024 / 1024 > 200) {
          this.$message.error('上传附件大小不能超过200MB!');
          return false;
        }
      },
      subComment () {
        let files = [];
        this.notefile.forEach(element => {
          files.push(element.response)
        });
        files = JSON.stringify(files)
        if (this.isButtonLoading) {
          return false
        }
        this.isButtonLoading = true
        // （1 评论 2 处理事件说明 3 转办）
        switch (Number(this.auditType.stat)) {
          case 1: this.commentFun(files)
            break;
          case 2: this.otherFun(files)
            break;
          case 3: this.trunToDoFun(files)
            break;
          case 4: this.circulation(files)
            break;
        }
      },
      //流转
      circulation (files) {
        console.log('流转操作',this.auditType.uid)
        let date = {
          notefile:files,
          comment: this.textarea,
          step: this.auditType.step,
          approvingId: this.auditType.approvingId,
          userapprovingId: this.auditType.userapprovingId
        }
        if (this.auditType.uid.checkedFlowArr) {
          let uids = this.auditType.uid.checkedFlowArr.map(element => {
            return element.organizationId
          });
          date.organizationsId = JSON.stringify(uids);
        }
        if (this.auditType.uid.checkedRoleArr) {
           let uids = this.auditType.uid.checkedRoleArr.map(element => {
            return element.roleId
          });
          date.rolesId = JSON.stringify(uids);
        }
        if (this.auditType.uid.checkedArrUser) {
          let uids = this.auditType.uid.checkedArrUser.map(element => {
            return element.userId
          });
          date.userIds = JSON.stringify(uids);
        }
        if (this.$route.query.spaceid) {
          date.spaceid = this.$route.query.spaceid
        }
        else if (this.$route.query.upaceid) {
          date.upaceid = this.$route.query.upaceid
        }
        openapiUpdatetransactor(date).then(res => {
          console.log(res)
          if (res && res.code == 0) {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.$emit("retSubComment", {
              key: 2,
              userapprovingId: this.auditType.userapprovingId
            });
            this.dialogVisible = false
            this.resetFun()
          } else {
            this.$message({
              type: "info",
              message: res.msg === '' ? '提交失败' : res.msg
            });
          }
          this.isButtonLoading = false
        }).catch(error => {
          console.log(error)
        })
      },
      //转办的事件
      trunToDoFun (files) {
        console.log('转办事件', this.auditType.uid,this.auditType.uid.checkedUserArr);
        let uids = this.auditType.uid.checkedUserArr.map(element => {
          return element.userId
        });
        // 去重处理
        uids = [...new Set(uids)]
        let date = {
          notefile:files,
          comment: this.textarea,
          way: 4,
          uids: uids.join(','),
          status: 1,
          userapprovingId: this.auditType.userapprovingId
        }
        if (this.$route.query.spaceid) {
          date.spaceid = this.$route.query.spaceid || localStorage.getItem('spaceid')
        }
        else if (this.$route.query.upaceid) {
          date.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
        }
        openapiUpdateuserapproving(date).then(res => {
          if (res && Number(res.code) === 0) {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.$emit('retSubComment', {isUp: true})
            this.$emit('retSubComment', {key: 1})
            this.dialogVisible = false
            this.resetFun()
          } else {
            this.$message({
              type: "info",
              message: res.msg === '' ? '提交失败' : res.msg
            });
          }
          this.isButtonLoading = false
        }).catch(error => { console.log(error) })
      },
      //其他提交事件
      otherFun (files) {
        if (Number(this.auditType.isComment) === 1 && this.textarea === '') {
          this.$message({
            type: 'error',
            message: '请输入评论内容'
          })
          this.isButtonLoading = false
          return false
        }
        if (Number(this.auditType.issign) === 1 && this.signImg === '') {
          this.$message({
            type: 'error',
            message: '请签名'
          })
          this.isButtonLoading = false
          return false
        }

        let date = {
          comment: this.textarea,
          notefile: files,
          sign: this.signImg,
          status: this.auditType.item,
          userapprovingId: this.auditType.userapprovingId
        }
        console.log("this.auditType==",this.auditType)
        if(this.auditType.formdata){
          const defaultKeyList = ['申请人_relation-user', '单号_text', '状态_status', '提交时间_date', '归档状态_status']
          defaultKeyList.forEach(key => {
            if (this.auditType.formdata[key]) {
              delete this.auditType.formdata[key]
            }
          })
        }
        date = Object.assign(date, this.auditType.formdata);
        if (this.auditType.isBatch) {
          this.$emit('allBatch', date)
          return
        }
        if (this.$route.query.spaceid) {
          date.spaceid = this.$route.query.spaceid  || localStorage.getItem('spaceid')
        }
        else if (this.$route.query.upaceid) {
          date.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
        }
        openapiUpdateuserapproving(date).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            //给到一个统一更新的状态
            // this.$emit('retSubComment', {isUp: true})
            // this.$emit('retSubComment', {key: 1})
            this.$emit('retSubComment', {isUp: true,key: 1})
            this.dialogAuditVisible = false;
            this.resetFun()
          } else {
            this.$message({
              type: "info",
              message: res.msg
            });
          }
          this.$emit('loadingFun', false)
          this.isButtonLoading = false
        }).catch(error => {console.log(error)})
      },
      //重置全部值
      resetFun () {
        this.textarea = '';
        this.notefile = []
        this.tabActive=0
        this.auditType = null
      },
      //评论事件
      commentFun (files) {
        let date = {
          note: this.textarea,
          notefile:files,
          userapprovingId: this.auditType.userapprovingId
        }
        if (this.$route.query.spaceid) {
          date.spaceid = this.$route.query.spaceid
        }
        else if (this.$route.query.upaceid) {
          date.upaceid = this.$route.query.upaceid
        }
        openapiReview(date).then(res => {
          if (res.code === 0) {
            this.$message({type: 'success', message: '评论成功'})
            this.dialogVisible = false
            this.resetFun()
            this.$emit('retSubComment')
          } else {
            this.$message({type: 'error', message: res.msg})
          }
          this.isButtonLoading = false
        }).catch(error => {
          this.isButtonLoading = false
          console.log(error)
        })
      },
      forJoin (e) {
        let date = []
        if (e.checkedFlow) {
          e.checkedFlowArr.forEach(val => {
            date.push(val.name)
          })
        }
        if (e.checkedRole) {
          e.checkedRoleArr.forEach(val => {
            date.push(val.name)
          })
        }
        if (e.checkedUser) {
          e.checkedUserArr.forEach(val => {
            date.push(val.realname)
          })
        }
        return date.join(',')
      },
      oaExamineCommentFun (e,isSign=false) {
        this.auditType = e;
        this.isSign = isSign
/*
        if (Number(e.stat) === 3) {
          //重置初始值
          // console.log('数据', e)
          let date = this.forJoin(e.uid)
          this.textarea = '请 ' + date + ' 协助处理'
        } else if (Number(e.stat) === 4) {
          let date = this.forJoin(e.uid)
          this.textarea = '请 ' + date + ' 协助处理'
        }
*/
        this.getComment();
        this.dialogVisible = true
      }
    }
  }
</script>
<style>
  .oa-examine-comment {
    background: #F2F2F2 !important;
  }
</style>
<style scoped lang="scss">
  .top-active{
    background: #d9d9d9;
  }
  .comment-text{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    box-sizing: border-box;
    padding: 0 20px;
    :deep(.el-input){
      line-height: 32px;
      height: 32px;
      width: 300px;
      .el-input__inner{
        line-height: 32px;
        height: 100%;  
      }
    }
    .todo-icon{
      display: flex;
      align-items: center;
      .WSicon-bianji1{
        margin: 0 10px;
      }
      .WSicon-datouding{
        font-size: 20px;
        color: #4e86ff;
      }
      .WSicon-datouding1{
        font-size: 18px;
        color: #333333;
      }
      .WSicon-shanchu1{
        font-size: 18px;
        color: #FC6A6A;
      }
    }
  }
  .textarea {
    position: relative;
  }
  .calbtn{
    height: 38px;
    margin-top: 14px;
    padding: 0 20px;
  }
  .calbtn .p{
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 30px;
    position: relative;
  }
  .calbtn .p.active::after{
    position: absolute;
    content: '';
    width:0;
    height:0;
    border-right:8px solid transparent;
    border-left:8px solid transparent;
    border-bottom:8px solid white;
    bottom: -14px;
    left: 2px;
  }
  .redDot::before{
    position: absolute;
    display: block;
    right: -2px;
    top: -2px;
    content: '';
    width:8px;
    height:8px;
    border-radius: 50%;
    background-color: red;
  }
  .calbtn .p .iconfont{
    font-size: 22px;
    }
  .add-often-block {
    height: 126px;
  }
  .scrollbarbox{
    height: 210px;
    width:100%;
    background: #fff;
  }
  .scrollbarbox .ul{
    padding: 20px;
    overflow: hidden;
  }
  .scrollbarbox .ul .canvas{
    border: 1px dashed #d9d9d9;
  }
  .scrollbarbox .ul .signBtns {
    position: absolute;
    right: 23px;
    top: 25px;
  }
  .scrollbarbox .ul .canvas {
    margin: 0 auto;
  }
  .scrollbarbox .ul .signBtn {
    padding: 6px 16px;
  }
  .scrollbarbox .ul .upfile{
    text-align: center;
    cursor: pointer;
    border: 2px dashed #d9d9d9;
    color: #2086DA;
    border-radius: 6px;
  }
  .scrollbarbox .ul .li {
    padding-bottom: 16px;
    position: relative;
    cursor: pointer;
  }
  .scrollbarbox .ul .li .p{
    padding-top: 4px;
    margin-right: 30px;
    font-size: 14px;
    color: #333333;
    width: 100%;
    text-align: left;
  }
  .scrollbarbox .ul .li .p:hover{
    color: #4e86ff;
  }
  .scrollbarbox .ul .li .icon-shanchu1{
    font-size: 24px;
    color: #FC6A6A;
  }
  .scrollbarbox .ul .li .icon-zhongmingming{
    font-size: 17px;
    color: #4e86ff;
  }
</style>
